
<div class="chats-page-container">
  <router-outlet></router-outlet>
</div>